var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCardGeneral(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 5.5,
    width: 31,
    height: 21,
    rx: 1.5,
    stroke: "#969EB1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3993 19C24.8591 19 24.3589 19.1728 23.9496 19.4652C23.5404 19.1728 23.0402 19 22.5 19C21.1215 19 20 20.1215 20 21.5C20 22.8785 21.1215 24 22.5 24C23.0402 24 23.5404 23.8272 23.9496 23.5348C24.3588 23.8272 24.8591 24 25.3993 24C26.7778 24 27.8993 22.8785 27.8993 21.5C27.8993 20.1215 26.7778 19 25.3993 19ZM23.2385 22.755C23.0218 22.883 22.7695 22.9568 22.5001 22.9568C21.6968 22.9568 21.0433 22.3033 21.0433 21.5C21.0433 20.6967 21.6968 20.0432 22.5001 20.0432C22.7695 20.0432 23.0218 20.117 23.2385 20.245C23.0233 20.6142 22.8993 21.0428 22.8993 21.5C22.8993 21.9572 23.0233 22.3858 23.2385 22.755ZM25.3993 22.9568C24.596 22.9568 23.9425 22.3033 23.9425 21.5C23.9425 20.6967 24.596 20.0432 25.3993 20.0432C26.2026 20.0432 26.8561 20.6967 26.8561 21.5C26.8561 22.3033 26.2026 22.9568 25.3993 22.9568Z",
    fill: "#969EB1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.551H31.0915",
    stroke: "#969EB1",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardGeneral);
export default __webpack_public_path__ + "static/media/credit-card-general.d1f1c7fae0ac66d853116f6b9741dd88.svg";
export { ForwardRef as ReactComponent };